import React, { useState, useEffect } from 'react'
import './mainPage.css'
import HeroSection from '../HeroSection/HeroSection';
import HorizontalNavBar from '../CustomComponents/HorizontalNavBar/HorizontalNavBar';
import video1 from '../../resources/VideoARH1.mp4'
import video2 from '../../resources/VideoARH.mp4'
import { YMaps, Map, Placemark } from 'react-yandex-maps'
import Footer from '../CustomComponents/Footer/Footer'
import Preloader from '../Preloader/Preloader'

const MainPage = () => {
  const [activeBlock, setActiveBlock] = useState(0); // По умолчанию открыт первый блок
  const [loading, setLoading] = useState(true);
  const [hoveredVideo, setHoveredVideo] = useState(true);
  const [hoveredDirector, setHoveredDirector] = useState(true);
  const [isTouchDevice, setIsTouchDevice] = useState(false);
  const [animationDone, setAnimationDone] = useState(false);
  const [pageLoaded, setPageLoaded] = useState(() => document.readyState === 'complete');

  useEffect(() => {
    const mq = window.matchMedia('(hover: none)');
    const updateTouchState = (event) => {
      setIsTouchDevice(event.matches);
    };

    // начальная инициализация
    setIsTouchDevice(mq.matches);
    if (typeof mq.addEventListener === 'function') {
      mq.addEventListener('change', updateTouchState);
      return () => mq.removeEventListener('change', updateTouchState);
    }

    mq.addListener(updateTouchState);
    return () => mq.removeListener(updateTouchState);
  }, []);

  useEffect(() => {
    if (!isTouchDevice) {
      setHoveredVideo(true);
      setHoveredDirector(true);
    } else {
      setHoveredVideo(false);
      setHoveredDirector(false);
    }
  }, [isTouchDevice]);

  useEffect(() => {
    const handleLoad = () => setPageLoaded(true)
    window.addEventListener('load', handleLoad)

    const animationDuration = 3000
    const buffer = 200
    const animationTimeout = window.setTimeout(() => setAnimationDone(true), animationDuration + buffer)

    const fallbackTimeout = window.setTimeout(() => {
      setAnimationDone(true)
      setPageLoaded(true)
    }, animationDuration + 5000)

    return () => {
      window.removeEventListener('load', handleLoad)
      window.clearTimeout(animationTimeout)
      window.clearTimeout(fallbackTimeout)
    }
  }, []);

  useEffect(() => {
    if (animationDone && pageLoaded) {
      setLoading(false)
    }
  }, [animationDone, pageLoaded]);

  const scrollToContent = () => {
    const nextSection = document.querySelector('.name_company');
    if (nextSection) {
      nextSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const toggleBlock = (index) => {
    // Закрывать блок кликом нельзя, только открывать другой
    if (activeBlock !== index) {
      setActiveBlock(index);
    }
    // Если кликаем на уже открытый блок - ничего не делаем (не закрываем)
  };

  const handleMediaHover = (setter, value) => {
    if (isTouchDevice) {
      return;
    }
    setter(value);
  };

  const handleMediaToggleTouch = (setter) => {
    if (!isTouchDevice) {
      return;
    }
    setter((prev) => !prev);
  };

  return (
    <>
          <div className={`preloader-wrapper ${loading ? 'visible' : 'hidden'}`}>
        <Preloader />
      </div>
      <HorizontalNavBar />
     
 <HeroSection onScrollClick={scrollToContent} />

      
      <h2 className="name_company">
         
    <br />
  
      </h2>
      
      
      <div className="company_description_block">
        <div
          className={`image-container ${hoveredVideo ? 'expanded' : ''}`}
          onMouseEnter={() => handleMediaHover(setHoveredVideo, true)}
          onMouseLeave={() => handleMediaHover(setHoveredVideo, false)}
          onClick={() => handleMediaToggleTouch(setHoveredVideo)}
        >
          <video 
            autoPlay 
            muted 
            loop 
            playsInline
            preload="metadata"
            className="background-video"
          >
            <source src={video1} type="video/mp4" />
            Ваш браузер не поддерживает видео.
          </video>
        </div>
        
        <div className={`description_container ${hoveredVideo ? 'shrinked' : ''}`}>
          {/* Первый блок - Приветствие  */}
          <div className={`text-block ${activeBlock === 0 ? 'active' : ''}`}>
            <div 
              className="block-header"
              onClick={() => toggleBlock(0)}
            >
              <h3 className="block-title">
                ARCHMIPLAN <br></br>проектная компания в сфере градостроительства и архитектуры
              </h3>
              <span className="arrow">
                <svg width="24" height="20" viewBox="0 0 30 25" fill="currentColor">
                  <path d="M17.8627 24.1455L29.5039 12.5591L17.8627 0.972761C17.7576 0.836059 17.624 0.723319 17.471 0.642175C17.3181 0.56103 17.1493 0.513374 16.9761 0.502433C16.8029 0.491493 16.6294 0.517523 16.4672 0.578762C16.3051 0.64 16.1581 0.735017 16.0363 0.85738C15.9145 0.979743 15.8206 1.1266 15.7611 1.288C15.7016 1.4494 15.6778 1.62158 15.6913 1.79288C15.7048 1.96418 15.7554 2.13061 15.8395 2.28089C15.9236 2.43117 16.0394 2.5618 16.1789 2.66394L24.8886 11.3597L1.71527 11.3597C1.39399 11.3597 1.08588 11.4861 0.858707 11.711C0.631533 11.9359 0.503906 12.241 0.503906 12.5591C0.503906 12.8772 0.631532 13.1823 0.858707 13.4072C1.08588 13.6322 1.39399 13.7585 1.71527 13.7585L24.8886 13.7585L16.1789 22.4543C15.9524 22.6802 15.8258 22.9859 15.827 23.3041C15.8281 23.6224 15.9569 23.9272 16.185 24.1515C16.4131 24.3758 16.7218 24.5011 17.0433 24.5C17.3647 24.4989 17.6726 24.3714 17.8991 24.1455L17.8627 24.1455Z"/>
                </svg>
              </span>
            </div>
            <div className="block-content">
              <div>
                <p className="description_company">
                  Мы разрабатываем комплексные решения — от мастер-планов и КРТ до архитектурного проектирования и дизайна интерьеров.
                </p>
                <p className="description_company">
                  Наш подход основан на стратегическом планировании, нормативной точности и ответственности за результат.
                </p>
                <p className="description_company">
                  Создаём устойчивую, рациональную и функциональную среду для жизни и развития.
                </p>
              </div>
            </div>
          </div>

{/* Второй блок - О компании  */}
          <div className={`text-block ${activeBlock === 1 ? 'active' : ''}`}>
            <div 
              className="block-header"
              onClick={() => toggleBlock(1)}
            >
              <h3 className="block-title">
                О КОМПАНИИ 
              </h3>
              <span className="arrow">
                <svg width="24" height="20" viewBox="0 0 30 25" fill="currentColor">
                  <path d="M17.8627 24.1455L29.5039 12.5591L17.8627 0.972761C17.7576 0.836059 17.624 0.723319 17.471 0.642175C17.3181 0.56103 17.1493 0.513374 16.9761 0.502433C16.8029 0.491493 16.6294 0.517523 16.4672 0.578762C16.3051 0.64 16.1581 0.735017 16.0363 0.85738C15.9145 0.979743 15.8206 1.1266 15.7611 1.288C15.7016 1.4494 15.6778 1.62158 15.6913 1.79288C15.7048 1.96418 15.7554 2.13061 15.8395 2.28089C15.9236 2.43117 16.0394 2.5618 16.1789 2.66394L24.8886 11.3597L1.71527 11.3597C1.39399 11.3597 1.08588 11.4861 0.858707 11.711C0.631533 11.9359 0.503906 12.241 0.503906 12.5591C0.503906 12.8772 0.631532 13.1823 0.858707 13.4072C1.08588 13.6322 1.39399 13.7585 1.71527 13.7585L24.8886 13.7585L16.1789 22.4543C15.9524 22.6802 15.8258 22.9859 15.827 23.3041C15.8281 23.6224 15.9569 23.9272 16.185 24.1515C16.4131 24.3758 16.7218 24.5011 17.0433 24.5C17.3647 24.4989 17.6726 24.3714 17.8991 24.1455L17.8627 24.1455Z"/>
                </svg>
              </span>
            </div>
            <div className="block-content">
              <div>
                <p className="description_company">
                 Архмиплан — архитектурное бюро, специализирующееся на комплексном градостроительном планировании и архитектурном проектировании.
                </p>
                <p className="description_company">
                  Мы разрабатываем мастер-планы, архитектурно-градостроительные концепции, документы территориального планирования, а также проектную и рабочую документацию для объектов различного масштаба.
                </p>
                <p className="description_company">
                  Объединяя стратегический подход, аналитическую точность и профессиональную экспертизу, мы формируем системные решения, обеспечивающие устойчивое развитие территорий.
                </p>
              </div>
            </div>
          </div>

          {/* Третий блок - Услуги*/}
          <div className={`text-block ${activeBlock === 2 ? 'active' : ''}`}>
            <div 
              className="block-header"
              onClick={() => toggleBlock(2)}
            >
              <h3 className="block-title">
                НАШИ УСЛУГИ
              </h3>
              <span className="arrow">
                <svg width="24" height="20" viewBox="0 0 30 25" fill="currentColor">
                  <path d="M17.8627 24.1455L29.5039 12.5591L17.8627 0.972761C17.7576 0.836059 17.624 0.723319 17.471 0.642175C17.3181 0.56103 17.1493 0.513374 16.9761 0.502433C16.8029 0.491493 16.6294 0.517523 16.4672 0.578762C16.3051 0.64 16.1581 0.735017 16.0363 0.85738C15.9145 0.979743 15.8206 1.1266 15.7611 1.288C15.7016 1.4494 15.6778 1.62158 15.6913 1.79288C15.7048 1.96418 15.7554 2.13061 15.8395 2.28089C15.9236 2.43117 16.0394 2.5618 16.1789 2.66394L24.8886 11.3597L1.71527 11.3597C1.39399 11.3597 1.08588 11.4861 0.858707 11.711C0.631533 11.9359 0.503906 12.241 0.503906 12.5591C0.503906 12.8772 0.631532 13.1823 0.858707 13.4072C1.08588 13.6322 1.39399 13.7585 1.71527 13.7585L24.8886 13.7585L16.1789 22.4543C15.9524 22.6802 15.8258 22.9859 15.827 23.3041C15.8281 23.6224 15.9569 23.9272 16.185 24.1515C16.4131 24.3758 16.7218 24.5011 17.0433 24.5C17.3647 24.4989 17.6726 24.3714 17.8991 24.1455L17.8627 24.1455Z"/>
                </svg>
              </span>
            </div>
            <div className="block-content">
              <div>
                <p className="description_company service-title">
                  ГРАДОСТРОИТЕЛЬНОЕ ПРОЕКТИРОВАНИЕ 
                </p>
                <p className="description_company">
                  Разработка КРТ, ППТ, ПЗЗ и мастер-планов. Анализ, планирование и моделирование развития территорий с учётом нормативных, функциональных и пространственных факторов.
                </p>
                
                <p className="description_company service-title">
                  АРХИТЕКТУРНОЕ ПРОЕКТИРОВАНИЕ
                </p>
                <p className="description_company">
                  Создание архитектурных концепций и проектной документации для жилых, общественных и производственных объектов. Функциональность, рациональность и выразительная форма — основа каждого решения.
                </p>
                
                <p className="description_company service-title">
                  ДИЗАЙН ИНТЕРЬЕРОВ 
                </p>
                <p className="description_company">
                  Формирование пространств, отвечающих потребностям человека и контексту объекта. От концепции до авторского сопровождения реализации.
                </p>

                <p className="description_company why-choose-us">
                  
                </p>
                
                <p className="description_company service-title">
                  
                </p>
                <p className="description_company">
                  
                </p>
                
                <p className="description_company service-title">
                 
                </p>
                <p className="description_company">
                  
                </p>
                
                <p className="description_company service-title">
                  
                </p>
                <p className="description_company">
                  
                </p>
              </div>
            </div>
          </div>

          {/* Четвертый блок - Проекты */}
          <div className={`text-block ${activeBlock === 3 ? 'active' : ''}`}>
            <div 
              className="block-header"
              onClick={() => toggleBlock(3)}
            >
              <h3 className="block-title">
                НАШИ ПРОЕКТЫ
              </h3>
              <span className="arrow">
                <svg width="24" height="20" viewBox="0 0 30 25" fill="currentColor">
                  <path d="M17.8627 24.1455L29.5039 12.5591L17.8627 0.972761C17.7576 0.836059 17.624 0.723319 17.471 0.642175C17.3181 0.56103 17.1493 0.513374 16.9761 0.502433C16.8029 0.491493 16.6294 0.517523 16.4672 0.578762C16.3051 0.64 16.1581 0.735017 16.0363 0.85738C15.9145 0.979743 15.8206 1.1266 15.7611 1.288C15.7016 1.4494 15.6778 1.62158 15.6913 1.79288C15.7048 1.96418 15.7554 2.13061 15.8395 2.28089C15.9236 2.43117 16.0394 2.5618 16.1789 2.66394L24.8886 11.3597L1.71527 11.3597C1.39399 11.3597 1.08588 11.4861 0.858707 11.711C0.631533 11.9359 0.503906 12.241 0.503906 12.5591C0.503906 12.8772 0.631532 13.1823 0.858707 13.4072C1.08588 13.6322 1.39399 13.7585 1.71527 13.7585L24.8886 13.7585L16.1789 22.4543C15.9524 22.6802 15.8258 22.9859 15.827 23.3041C15.8281 23.6224 15.9569 23.9272 16.185 24.1515C16.4131 24.3758 16.7218 24.5011 17.0433 24.5C17.3647 24.4989 17.6726 24.3714 17.8991 24.1455L17.8627 24.1455Z"/>
                </svg>
              </span>
            </div>
            <div className="block-content">
              <div>
                <p className="description_company">
                 Мы реализуем проекты различного масштаба — от градостроительных схем и генеральных планов до архитектурных объектов и интерьеров.
                </p>
                <p className="description_company">
                 Каждый проект — результат аналитического подхода, нормативной точности и системной работы команды.
                </p>
                <p className="description_company">
                 Архмиплан создаёт архитектуру, которая формирует пространство, а не просто занимает его.
                </p>
              </div>
            </div>
          </div>

          {/* Пятый блок - Контакты */}
          <div className={`text-block ${activeBlock === 4 ? 'active' : ''}`}>
            <div 
              className="block-header"
              onClick={() => toggleBlock(4)}
            >
              <h3 className="block-title">
                КОНТАКТЫ
              </h3>
              <span className="arrow">
                <svg width="24" height="20" viewBox="0 0 30 25" fill="currentColor">
                  <path d="M17.8627 24.1455L29.5039 12.5591L17.8627 0.972761C17.7576 0.836059 17.624 0.723319 17.471 0.642175C17.3181 0.56103 17.1493 0.513374 16.9761 0.502433C16.8029 0.491493 16.6294 0.517523 16.4672 0.578762C16.3051 0.64 16.1581 0.735017 16.0363 0.85738C15.9145 0.979743 15.8206 1.1266 15.7611 1.288C15.7016 1.4494 15.6778 1.62158 15.6913 1.79288C15.7048 1.96418 15.7554 2.13061 15.8395 2.28089C15.9236 2.43117 16.0394 2.5618 16.1789 2.66394L24.8886 11.3597L1.71527 11.3597C1.39399 11.3597 1.08588 11.4861 0.858707 11.711C0.631533 11.9359 0.503906 12.241 0.503906 12.5591C0.503906 12.8772 0.631532 13.1823 0.858707 13.4072C1.08588 13.6322 1.39399 13.7585 1.71527 13.7585L24.8886 13.7585L16.1789 22.4543C15.9524 22.6802 15.8258 22.9859 15.827 23.3041C15.8281 23.6224 15.9569 23.9272 16.185 24.1515C16.4131 24.3758 16.7218 24.5011 17.0433 24.5C17.3647 24.4989 17.6726 24.3714 17.8991 24.1455L17.8627 24.1455Z"/>
                </svg>
              </span>
            </div>
            <div className="block-content">
  <div>
    <span className="description_company-contact-line">Адрес: ул.Магомета Гаджиева, 73А</span>
    <span className="description_company-contact-line">Телефон: +7 988 206-96-39</span>
    <span className="description_company-contact-line">Email: arcgmiplan@gmail.com</span>
  </div>
            </div>
          </div>
        </div>
      </div>
      
      {/* Остальной код без изменений */}
<div className="dir_description_block">
  <div
    className={`image-container ${hoveredDirector ? 'expanded' : ''}`}
    onMouseEnter={() => handleMediaHover(setHoveredDirector, true)}
    onMouseLeave={() => handleMediaHover(setHoveredDirector, false)}
    onClick={() => handleMediaToggleTouch(setHoveredDirector)}
  >
    <video 
      autoPlay 
      muted 
      loop 
      playsInline
      preload="metadata"
      className="background-video"
    >
      <source src={video2} type="video/mp4" />
      Ваш браузер не поддерживает видео.
    </video>
  </div>
  
  <div className={`dir_description_container ${hoveredDirector ? 'shrinked' : ''}`}>
    <h1 className="name_dir">
    МЕТОДОЛОГИЯ РАБОТЫ

    </h1>
    
    <div className="about_dir">
      <h2>• Интегрированный подход к территориальному развитию </h2>
      
      <p>— объединение градостроительного анализа, архитектурного проектирования и инженерных решений в единую стратегию устойчивого освоения территории.</p>

      <h3>• Аналитическая основа решений</h3>
      <p>— разработка проектов на основе пространственного, социально-экономического и экологического анализа, с использованием ГИС-технологий и актуальных данных.</p>

      <h2>• Координация с региональными и муниципальными стратегиями</h2>
      <p>— обеспечение соответствия федеральным и региональным документам территориального планирования и программам социально-экономического развития.</p>

      <h3>• Участие профессиональных сообществ и экспертов</h3>
      <p>— формирование проектных команд с привлечением профильных специалистов (урбанистов, инженеров, экологов, социологов) для комплексного подхода.</p>

      <h3>• Ориентация на качество городской среды</h3>
      <p>— приоритет формирования комфортных, безопасных и идентичных пространств, соответствующих современным принципам «человекоцентричного» проектирования.</p>

      <h3></h3>
      <p></p>
    </div>
  </div>
</div>
      
      {/* <h2 className="name_street">
        Заменить нижний текст 
        <br />
  уточнить 
      </h2>
      
      <div className="container_map">
        <YMaps>
          <Map 
            defaultState={{ 
              center: [42.975976, 47.498079], 
              zoom: 19 
            }} 
            width={400} 
            height={300}
          >
            <Placemark geometry={[42.975976, 47.498079]} />
          </Map>
        </YMaps>
      </div> */}
      
      <Footer />
    </>
  )
}

export default MainPage